<template>
  <div class="container">
    <section class="hero-section">
      <div class="decoration star-1">
        <img :src="xiaoxiong" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>
      <div class="decoration star-2">
        <img :src="gouzi" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>
      <div class="decoration star-3">
        <img :src="xianhua" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-4">
        <img :src="aixin" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-5">
        <img :src="baobao" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-6">
        <img :src="huazhuangping" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-7">
        <img :src="chezi" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-8">
        <img :src="fangzi" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-9">
        <img :src="piaozi" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <div class="decoration star-10">
        <img :src="shoutao" :width="starSize" :height="starSize" @click="handleStarClick"/>
      </div>

      <h1 class="hero-title">Happy Birthday!</h1>

      <img ref="masterImg" :src="bgs[currentIndex]" width="220px" height="220px" alt="Cinnamoroll" class="cinnamoroll-img" @click="handleMasterClick" />


      <div class="message-card">
        <p class="message-text" v-html="displayHtml"></p>
      </div>

      <div v-if="showNext" class="next-chapter" @click="goNextChapter" role="button" tabindex="0">
        <span>下一章</span>
      </div>
    </section>

    <!-- confetti canvas (fixed full-screen, pointer-events:none so it doesn't block UI) -->
    <canvas id="confetti-canvas" ref="confettiCanvas"></canvas>

  </div>

<!-- Ready overlay with floating envelope (based on demo/index5.html) -->
<div v-if="showReadyModal" class="ready-modal-overlay">
  <div ref="envelopeWrapper" class="envelope-wrapper" @click="onReadyConfirm" role="button" aria-label="开启祝福">
    <div class="envelope">
      <div class="flap"></div>
      <div class="pocket"></div>
      <div class="letter">
        <p>To: 最可爱的宝</p>
      </div>
    </div>

    <div class="heart-seal" @click.stop="onReadyConfirm" aria-label="拆信">
      <span>❤</span>
    </div>

    <div class="hint-text">点击爱心 开启祝福</div>
  </div>
</div>

</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import bgImage from '../assets/daergou_caihong.jpg'
import bgImage3 from '../assets/daergou2.jpg'
// 按照生命节点排序：  小熊、金毛狗子、花、爱心、包包、化妆品、车子、房子、票子、寿桃
import xiaoxiong from '../assets/xiaoxiong.png'
import xianhua from '../assets/xianhua.png'
import aixin from '../assets/aixin.png'
import gouzi from '../assets/gouzi.png'
import baobao from '../assets/baobao.png'
import huazhuangping from '../assets/huazhuangping.png'
import chezi from '../assets/chezi.png'
import fangzi from '../assets/fangzi.png'
import piaozi from '../assets/piaozi.png'
import shoutao from '../assets/shoutao.png'

const props = defineProps({
  isPlaying: Boolean,
  toggleMusic: Function
})

const confettiCanvas = ref(null)
const masterImg = ref(null)
const bgs = [bgImage, bgImage3]
const currentIndex = ref(0)
const starSize = ref("40px")
let bgTimeout = null
const emit = defineEmits(['next-chapter'])
const showNext = ref(false)
// try to start audio on first user gesture (click/touch)
const handleFirstUserInteraction = () => {
  if (!props.toggleMusic) return
  try {
    props.toggleMusic()
  } catch (err) {
    // play may fail if browser still blocks it; ignore
  }
}
// --- typing effect state ---
const fullText = '宝，生日快乐。 <br>愿生活把最温柔的风和最软的云都留给你， <br>让你像大耳狗一样， <br>拥有飞越一切烦恼的翅膀， <br>自在如风，可爱如初。'
const displayText = ref('')
const displayHtml = computed(() => displayText.value + '<span class="type-cursor"></span>')
let typingTimer = null
let typingContext = null

const tokenizeHtml = (str) => {
  const tokens = []
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '<') {
      // capture whole tag
      let j = i
      while (j < str.length && str[j] !== '>') j++
      tokens.push(str.slice(i, j + 1))
      i = j
    } else {
      tokens.push(str[i])
    }
  }
  return tokens
}

const playClick = () => {
  try {
    if (!typingContext) typingContext = new (window.AudioContext || window.webkitAudioContext)()
    const ctx = typingContext
    const o = ctx.createOscillator()
    const g = ctx.createGain()
    o.type = 'square'
    o.frequency.value = 900
    g.gain.value = 0.06
    o.connect(g)
    g.connect(ctx.destination)
    o.start()
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.08)
    o.stop(ctx.currentTime + 0.09)
  } catch (e) {
    // audio context might be blocked; ignore
  }
}

const startTyping = (speed = 100) => {
  showNext.value = false
  const tokens = tokenizeHtml(fullText)
  let idx = 0
  const tick = () => {
    if (idx >= tokens.length) {
      typingTimer = null
      // typing finished -> show next chapter button
      showNext.value = true
      return
    }
    const tok = tokens[idx++]
    displayText.value += tok
    // play click for visible characters (ignore tags and spaces)
    if (!tok.startsWith('<') && tok.trim() !== '') playClick()
    // pause a bit longer on punctuation
    let delay = speed
    if (/[，。！？,.!?]/.test(tok)) delay = speed * 8
    typingTimer = setTimeout(tick, delay)
  }
  if (typingTimer) clearTimeout(typingTimer)
  displayText.value = ''
  typingTimer = setTimeout(tick, speed)
}

const stopTyping = () => {
  if (typingTimer) {
    clearTimeout(typingTimer)
    typingTimer = null
  }
  if (typingContext) {
    try {
      typingContext.close?.()
    } catch (e) {
      console.warn('typingContext.close failed', e)
    }
    typingContext = null
  }
}

// --- star click scale handling ---
const starTimers = new Map()
const handleStarClick = (e) => {
  const el = e.currentTarget
  // ensure it's the img element
  if (!el) return
  // clear existing timer if any
  if (starTimers.has(el)) {
    clearTimeout(starTimers.get(el))
    starTimers.delete(el)
  }
  // add scale class to trigger CSS transform
  el.classList.add('star-scale')
  // after 1.5s remove class to scale back (transition handles smoothness)
  const t = setTimeout(() => {
    el.classList.remove('star-scale')
    starTimers.delete(el)
  }, 1500)
  starTimers.set(el, t)
}

const nextBg = () => {
  currentIndex.value = (currentIndex.value + 1) % bgs.length
}

const scheduleAutoBg = () => {
  if (bgTimeout) clearTimeout(bgTimeout)
  bgTimeout = setTimeout(() => {
    nextBg()
    scheduleAutoBg()
  }, 3000)
}

const handleMasterClick = () => {
  nextBg()
  scheduleAutoBg()
}

onMounted(() => {
  const canvas = confettiCanvas.value
  if (!canvas) return
  const ctx = canvas.getContext('2d')
  let w = 0
  let h = 0
  const colors = ['#F7C8D8', '#FEF4C0', '#BBE2F1', '#FFFFFF', '#C3E6F5']
  const shapes = ['square', 'ribbon', 'star']
  const particles = []
  const maxParticles = 120
  let rafId = null

  function resize() {
    w = canvas.width = window.innerWidth
    h = canvas.height = window.innerHeight
  }
  window.addEventListener('resize', resize)
  resize()
  scheduleAutoBg()

  class Particle {
    constructor(firstRun = true) {
      this.reset(firstRun)
    }
    reset(firstRun = false) {
      const side = Math.random() > 0.5 ? 'left' : 'right'
      if (side === 'left') {
        this.x = Math.random() * (w * 0.3)
      } else {
        this.x = w * 0.7 + Math.random() * (w * 0.3)
      }
      this.y = firstRun ? -Math.random() * h : -20
      this.vx = (Math.random() - 0.5) * 2
      this.vy = Math.random() * 2 + 1
      this.rotation = Math.random() * Math.PI * 2
      this.rotationSpeed = (Math.random() - 0.5) * 0.05
      this.color = colors[Math.floor(Math.random() * colors.length)]
      this.shape = shapes[Math.floor(Math.random() * shapes.length)]
      if (this.shape === 'ribbon') {
        this.width = Math.random() * 5 + 3
        this.height = Math.random() * 15 + 10
      } else {
        this.size = Math.random() * 10 + 5
      }
    }
    update() {
      this.x += this.vx
      this.y += this.vy
      this.rotation += this.rotationSpeed
      if (this.y > h + 20) this.reset()
    }
    draw() {
      ctx.save()
      ctx.translate(this.x, this.y)
      ctx.rotate(this.rotation)
      ctx.fillStyle = this.color
      if (this.shape === 'square') {
        ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size)
      } else if (this.shape === 'ribbon') {
        ctx.fillRect(-this.width / 2, -this.height / 2, this.width, this.height)
      } else if (this.shape === 'star') {
        this.drawStar(0, 0, 5, this.size, this.size / 2)
      }
      ctx.restore()
    }
    drawStar(cx, cy, spikes, outerRadius, innerRadius) {
      let rot = Math.PI / 2 * 3
      let x = cx
      let y = cy
      let step = Math.PI / spikes
      ctx.beginPath()
      ctx.moveTo(cx, cy - outerRadius)
      for (let i = 0; i < spikes; i++) {
        x = cx + Math.cos(rot) * outerRadius
        y = cy + Math.sin(rot) * outerRadius
        ctx.lineTo(x, y)
        rot += step
        x = cx + Math.cos(rot) * innerRadius
        y = cy + Math.sin(rot) * innerRadius
        ctx.lineTo(x, y)
        rot += step
      }
      ctx.lineTo(cx, cy - outerRadius)
      ctx.closePath()
      ctx.fill()
    }
  }

  function initConfetti() {
    for (let i = 0; i < maxParticles; i++) {
      particles.push(new Particle(true))
    }
  }

  function animateConfetti() {
    ctx.clearRect(0, 0, w, h)
    for (let i = 0; i < particles.length; i++) {
      particles[i].update()
      particles[i].draw()
    }
    rafId = requestAnimationFrame(animateConfetti)
  }

  initConfetti()
  animateConfetti()

  onBeforeUnmount(() => {
    window.removeEventListener('resize', resize)
    if (rafId) cancelAnimationFrame(rafId)
    if (bgTimeout) clearTimeout(bgTimeout)
  })
})

// ------------------ 移除音乐播放逻辑，改为使用父组件提供的 props ------------------

onBeforeUnmount(() => {
  // clear any pending star scale timers
  for (const t of starTimers.values()) {
    clearTimeout(t)
  }
  starTimers.clear()
})

// show initial "ready" modal; user must click to begin (ensures gesture to unlock audio)
const showReadyModal = ref(true)
const envelopeWrapper = ref(null)
onBeforeUnmount(() => {
  stopTyping()
})
// Removed automatic start: wait for user to confirm via the ready modal.
const onReadyConfirm = async () => {
  const envelope = envelopeWrapper.value
  if (envelope) {
    // Add shake animation to envelope
    envelope.classList.add('shake')

    // Add pulse animation to heart
    const heartSeal = envelope.querySelector('.heart-seal')
    if (heartSeal) {
      heartSeal.classList.add('pulse')
    }

    // Remove animation classes after they complete
    setTimeout(() => {
      envelope.classList.remove('shake')
      if (heartSeal) {
        heartSeal.classList.remove('pulse')
      }
    }, 600)

    // Add exit animation to envelope after a brief delay
    setTimeout(() => {
      envelope.style.transition = "all 0.8s ease"
      envelope.style.opacity = "0"
      envelope.style.transform = "scale(1.5) rotate(-10deg)"
    }, 200)
  }

  // Wait for animation to complete, then hide modal
  setTimeout(() => {
    showReadyModal.value = false
  }, 1000)

  // start typing after message-card entrance delay so animation stays smooth
  setTimeout(() => startTyping(), 500)

  handleFirstUserInteraction()
}
const goNextChapter = () => {
  emit('next-chapter')
}
</script>

<style scoped>
:root {
  --bg-blue: #BBE2F1;
  --cloud-white: #FFFFFF;
  --soft-pink: #F7C8D8;
  --text-color: #7B92B7;
  --card-shadow: 0 8px 20px rgba(123, 146, 183, 0.2);
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg-blue);
  font-family: "Varela Round", "YouYuan", "幼圆", sans-serif;
  color: var(--text-color);
  overflow-x: hidden;
}

/* --- 动画定义 --- */
@keyframes float {
  0% { transform: translateY(0px) rotate(-2deg); }
  50% { transform: translateY(-15px) rotate(2deg); }
  100% { transform: translateY(0px) rotate(-2deg); }
}

@keyframes popUp {
  0% { transform: scale(0); opacity: 0; }
  80% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

/* Import friendly rounded/cartoon fonts */
@import url('https://fonts.googleapis.com/css2?family=Fredoka+One&family=Pacifico&display=swap');

/* Title drop and message slide-up with bounce */
@keyframes drop-down {
  0% { transform: translateY(-60px) scale(0.98); opacity: 0; }
  60% { transform: translateY(8px) scale(1.02); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes slide-up-bounce {
  0% { transform: translateY(60px) scale(0.98); opacity: 0; }
  60% { transform: translateY(-8px) scale(1.02); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

.container {
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
  color: #2c3e50;
  margin-top: 60px;
}

.hero-section {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 40px;
  position: relative;
}

.hero-title {
  font-size: 2.4em;
  color: #ffd1e6; /* soft pink text */
  font-family: 'Fredoka One', 'Pacifico', "Varela Round", sans-serif;
  font-weight: 700;
  margin-bottom: 20px;
  /* white outline stroke + fallback via text-shadow for non-webkit */
  -webkit-text-stroke: 2px #ffffff;
  text-shadow:
    -1px -1px 0 #fff,
    1px -1px 0 #fff,
    -1px 1px 0 #fff,
    1px 1px 0 #fff,
    2px 2px 8px rgba(0,0,0,0.12);
  /* entrance animation */
  animation: drop-down 0.9s cubic-bezier(.2,.9,.3,1) 0.08s both;
}

.cinnamoroll-img {
  width: 220px;
  animation: float 3.5s ease-in-out infinite alternate;
  filter: drop-shadow(0 10px 10px rgba(255,255,255,0.5));
  position: relative;
  z-index: 10;
  border-radius: 18px;
  box-shadow: 0 14px 30px rgba(135,206,250,0.22), 0 6px 12px rgba(0,0,0,0.08);
}

.message-card {
  border: 2px dashed var(--bg-blue);
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  background: #FAFDFF;
  /* slide-up + bounce entrance */
  animation: slide-up-bounce 0.9s cubic-bezier(.2,.9,.3,1) 0.36s both;
}

.message-text {
  font-size: 1.05em;
  line-height: 1.8;
  margin: 0;
  color: var(--text-color);
}

.decoration {
  position: absolute;
  font-size: 24px;
  opacity: 0.8;
  z-index: 30;
}
.star-1 { top: 55%; left: 5%; animation: float 5s infinite; }
.star-2 { top: 55%; left: 15%; animation: float 5s infinite reverse; }
.star-3 { top: 55%; left: 25%; animation: float 5s infinite; }
.star-4 { top: 55%; left: 35%; animation: float 5s infinite; }
.star-5 { top: 55%; left: 45%; animation: float 5s infinite; }
.star-6 { top: 55%; right: 45%; animation: float 5s infinite reverse; }
.star-7 { top: 55%; right: 35%; animation: float 5s infinite reverse; }
.star-8 { top: 55%; right: 25%; animation: float 5s infinite reverse; }
.star-9 { top: 55%; right: 15%; animation: float 5s infinite reverse; }
.star-10 { top: 55%; right: 5%; animation: float 5s infinite reverse; }

/* Motion system for decorations: variable-driven, GPU-friendly transforms */
.decoration {
  /* defaults (overridden per .star-n)
     Use viewport units so amplitudes scale with screen size and stay within view.
     --ax uses vw (horizontal), --ay uses vh (vertical). */
  --ax: 3vw;        /* horizontal amplitude */
  --ay: 2vh;        /* vertical amplitude */
  --dur: 5s;         /* duration */
  --delay: 0s;       /* start delay */
  --rot: 6deg;       /* rotation range */
  --easing: ease-in-out;
  z-index: 30;
}

@keyframes float-vertical {
  0% { transform: translate3d(0, calc(-1 * var(--ay)), 0) rotate(calc(-1 * var(--rot))); }
  100% { transform: translate3d(0, var(--ay), 0) rotate(var(--rot)); }
}

@keyframes float-horizontal {
  0% { transform: translate3d(calc(-1 * var(--ax)), 0, 0) rotate(calc(-1 * var(--rot))); }
  100% { transform: translate3d(var(--ax), 0, 0) rotate(var(--rot)); }
}

@keyframes float-diagonal {
  0% { transform: translate3d(calc(-1 * var(--ax)), calc(-1 * var(--ay)), 0) rotate(calc(-1 * var(--rot))); }
  100% { transform: translate3d(var(--ax), var(--ay), 0) rotate(var(--rot)); }
}

@keyframes float-arc {
  0% { transform: translate3d(calc(-1 * var(--ax)), calc(-0.6 * var(--ay)), 0) rotate(calc(-1 * var(--rot))); }
  50% { transform: translate3d(0, calc(0.8 * var(--ay)), 0) rotate(0deg); }
  100% { transform: translate3d(var(--ax), calc(-0.2 * var(--ay)), 0) rotate(var(--rot)); }
}

@keyframes float-circle {
  0% { transform: translate3d(var(--ax), 0, 0) rotate(0deg); }
  25% { transform: translate3d(0, var(--ay), 0) rotate(90deg); }
  50% { transform: translate3d(calc(-1 * var(--ax)), 0, 0) rotate(180deg); }
  75% { transform: translate3d(0, calc(-1 * var(--ay)), 0) rotate(270deg); }
  100% { transform: translate3d(var(--ax), 0, 0) rotate(360deg); }
}

@keyframes jitter {
  0% { transform: translate3d(-2px, 0, 0); }
  50% { transform: translate3d(2px, 0, 0); }
  100% { transform: translate3d(-2px, 0, 0); }
}

/* Per-star tuning: amplitudes, durations, delays, easing, and animation choice */
.star-1 {
  --ax: 0.6vw; --ay: 2vh; --dur: 5s; --delay: 0s; --rot: 6deg;
  animation: float-vertical var(--dur) var(--easing) var(--delay) infinite alternate;
  opacity: 0.95;
}
.star-2 {
  --ax: 6vw; --ay: 3.5vh; --dur: 7s; --delay: 0.6s; --rot: 10deg;
  animation: float-diagonal var(--dur) ease-in-out var(--delay) infinite alternate-reverse;
}
.tar-3-fix, .star-3 {
  --ax: 3.6vw; --ay: 1.2vh; --dur: 4.2s; --delay: 0.2s; --rot: 8deg;
  animation: float-horizontal var(--dur) cubic-bezier(.4,0,.2,1) var(--delay) infinite alternate;
}
.star-4 {
  --ax: 10vw; --ay: 6vh; --dur: 9s; --delay: 1s; --rot: 12deg;
  animation: float-arc var(--dur) var(--easing) var(--delay) infinite alternate;
}
.star-5 {
  --ax: 1.6vw; --ay: 5vh; --dur: 6.5s; --delay: 0.4s; --rot: 6deg;
  animation: float-vertical var(--dur) ease-out var(--delay) infinite alternate;
}
.star-6 {
  --ax: 5.6vw; --ay: 4vh; --dur: 8s; --delay: 0.8s; --rot: 10deg;
  animation: float-diagonal var(--dur) var(--easing) var(--delay) infinite alternate-reverse;
}
.star-7 {
  --ax: 3.6vw; --ay: 3.6vh; --dur: 5.5s; --delay: 0.3s; --rot: 15deg;
  animation: float-circle var(--dur) linear var(--delay) infinite;
}
.star-8 {
  --ax: 1.2vw; --ay: 4vh; --dur: 10s; --delay: 0s; --rot: 4deg;
  animation: jitter 0.9s linear 0s infinite, float-vertical var(--dur) var(--easing) var(--delay) infinite alternate;
}
.star-9 {
  --ax: 12vw; --ay: 7vh; --dur: 10s; --delay: 0.7s; --rot: 18deg;
  animation: float-arc var(--dur) cubic-bezier(.2,1.2,.4,1) var(--delay) infinite alternate;
}
.star-10 {
  --ax: 8vw; --ay: 5vh; --dur: 12s; --delay: 1.2s; --rot: 8deg;
  animation: float-arc var(--dur) var(--easing) var(--delay) infinite alternate;
  opacity: 0.75;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.decoration img {
  transition: transform 0.6s cubic-bezier(.2,.9,.3,1), box-shadow 0.4s ease;
  transform-origin: center center;
  will-change: transform;
}
.decoration img.star-scale {
  transform: scale(3);
  z-index: 60;
  box-shadow: 0 30px 60px rgba(135,206,250,0.28);
}

.next-chapter {
  margin-top: 18px;
  display: inline-block;
  padding: 10px 16px;
  background: linear-gradient(90deg,#ffd1e6,#ff9a9e);
  color: #fff;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(255,140,160,0.18);
  font-weight: 700;
  z-index: 40;
  user-select: none;
}
.next-chapter:active { transform: scale(0.98); }

.ready-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* slightly darker like demo */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
  z-index: 1200;
}

/* envelope outer wrapper (float animation + slight rotate) */
.envelope-wrapper {
  position: relative;
  cursor: pointer;
  animation: floatEnvelope 3s ease-in-out infinite;
  transform: rotate(-10deg);
  transition: animation-duration 0.3s ease;
}

.envelope-wrapper.shake {
  animation: floatEnvelope 0.6s ease-in-out, envelopeShake 0.4s ease-in-out;
}

/* envelope body */
.envelope {
  position: relative;
  width: 280px;
  height: 180px;
  background: #fff5f7; /* light pink paper */
  border-radius: 10px;
  box-shadow:
    0 20px 40px rgba(0,0,0,0.15),
    0 15px 35px rgba(255,143,163,0.1),
    0 0 60px rgba(255,255,255,0.3);
  overflow: hidden;
}

/* flap (top triangle) */
.flap {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-left: 140px solid transparent;
  border-right: 140px solid transparent;
  border-top: 100px solid #ffdde1; /* flap color */
  z-index: 2;
  transform-origin: top;
}

/* pocket (bottom triangle) */
.pocket {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 0;
  border-left: 140px solid transparent;
  border-right: 140px solid transparent;
  border-bottom: 90px solid #ffeef0; /* pocket color */
  z-index: 3;
}

/* inner letter visible area */
.letter {
  position: absolute;
  left: 0;
  top: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.letter p {
  margin: 0;
  font-family: 'Pacifico', cursive;
  color: #3b3b3b;
  font-size: 20px;
}

/* heart seal (button) */
.heart-seal {
  position: absolute;
  top: 68px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background: #ff8fa3;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 10px rgba(255, 143, 163, 0.4);
  z-index: 4;
  transition: transform 0.2s;
}

.heart-seal.pulse {
  animation: heartPulse 0.6s ease-in-out;
}

.envelope-wrapper:active .heart-seal { transform: translateX(-50%) scale(0.9); }

.hint-text {
  margin-top: 16px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

@keyframes floatEnvelope {
  0%,100% { transform: translateY(0) rotate(-3deg); }
  50% { transform: translateY(-20px) rotate(-3deg); }
}

@keyframes envelopeShake {
  0%, 100% { transform: translateY(0) rotate(-3deg) scale(1); }
  25% { transform: translateY(-2px) rotate(-3.5deg) scale(1.02); }
  50% { transform: translateY(0) rotate(-2.5deg) scale(0.98); }
  75% { transform: translateY(2px) rotate(-3.2deg) scale(1.01); }
}

@keyframes heartPulse {
  0%, 100% { transform: translateX(-50%) scale(1); }
  50% { transform: translateX(-50%) scale(1.15); }
}
</style>

<style>
:root {
  --bg-blue: #BBE2F1;
  --cloud-white: #FFFFFF;
  --soft-pink: #F7C8D8;
  --text-color: #7B92B7;
  --card-shadow: 0 8px 20px rgba(123, 146, 183, 0.2);
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg-blue);
  font-family: "Varela Round", "YouYuan", "幼圆", sans-serif;
  color: var(--text-color);
  overflow-x: hidden;
}
/* confetti canvas: full-screen, non-blocking */
#confetti-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}
</style>
